import type { ReactNode } from 'react';
import { Box, Stack, Typography, type SxProps, type Theme } from '@mui/material';

export type AppModuleScaffoldProps = {
  title: string;
  description?: string;
  actionLeft?: ReactNode;
  actionRight?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Encabezado de módulo al estilo app móvil: título grande, bajada, fila de acciones.
 */
export default function AppModuleScaffold({ title, description, actionLeft, actionRight, children, sx = {} }: AppModuleScaffoldProps) {
  return (
    <Box sx={{ width: 1, minWidth: 0, maxWidth: 720, mx: 'auto', ...sx }}>
      <Box component="header" sx={{ px: 0, pt: 0, pb: 2 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 800, fontSize: { xs: '1.4rem', sm: '1.75rem' }, lineHeight: 1.2, color: 'text.primary' }}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, lineHeight: 1.5, maxWidth: 560 }}>
            {description}
          </Typography>
        )}
        {(actionLeft || actionRight) && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            gap={1.5}
            sx={{ mt: 2, rowGap: 1 }}
          >
            <Box sx={{ flex: '0 0 auto' }}>{actionLeft}</Box>
            <Box
              sx={{
                flex: '1 1 auto',
                minWidth: 0,
                display: 'flex',
                justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                ml: { xs: 0, sm: 2 },
              }}
            >
              {actionRight}
            </Box>
          </Stack>
        )}
      </Box>
      <Box sx={{ color: 'text.primary', '& a': { fontWeight: 600 } }}>{children}</Box>
    </Box>
  );
}
